import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { Card, Col, Layout, Row, Spin } from 'antd';
import { Redirect } from 'react-router-dom';

// Actions
import { processInvitationLink } from '../../data/homes/actions';
import { onInvitationAccepted } from '../../data/app/actions';

// Selectors
import { getInvitationAcceptedState } from '../../data/app/selector';

// Other
import { strings } from '../../localization';
import { ROUTE_NAMES } from '../../utils';
import InvitationWrongUserScreen from './InvitationWrongUserScreen';

class Invitation extends PureComponent {
    componentWillMount() {
        const { onInvitationAccepted } = this.props;
        onInvitationAccepted(false);
    }

    componentDidMount() {
        const { match, processInvitationLink } = this.props;
        processInvitationLink(match.params, match.url.indexOf('invitation-owner') > 0);
    }

    render() {
        const { invitationAccepted, logout } = this.props;
        if (invitationAccepted) {
            switch (invitationAccepted) {
                case 'error':
                    return <InvitationWrongUserScreen logout={logout} />
                case 'success':
                default:
                    return <Redirect to={ROUTE_NAMES.DASHBOARD} />;
            }
        }
        return (
            <Layout key="admin-users-content">
                <Layout.Content style={{ padding: '10px' }}>
                    <Row>
                        <Col xs={24}>
                            <Card bodyStyle={{ padding: 0, textAlign: 'center', margin: '30px auto' }}>
                                <Spin size="large" style={{ margin: '30px auto' }} />
                                <h3>{strings.homes.processingInvitationLink}</h3>
                            </Card>
                        </Col>
                    </Row>
                </Layout.Content>
            </Layout>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        invitationAccepted: getInvitationAcceptedState(state)
    }),
    {
        processInvitationLink,
        onInvitationAccepted
    }
)(Invitation);
